import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function About() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-paper">
      <Navbar />
      <main className="pt-24 md:pt-32 pb-20">
        <div className="w-full px-4 md:px-8 lg:px-12 mb-16 md:mb-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold mb-4">{t("about.storyLabel")}</p>
              <h1 className="font-serif text-4xl md:text-5xl font-semibold text-ink mb-6 leading-tight">{t("about.storyTitle")}</h1>
              <div className="space-y-4 text-ink/60 font-light leading-relaxed">
                <p>{t("about.storyP1")}</p>
                <p>{t("about.storyP2")}</p>
                <p>{t("about.storyP3")}</p>
              </div>
            </div>
            <div className="relative">
              <img src="https://readdy.ai/api/search-image?query=Traditional%20Japanese%20wooden%20workshop%20interior%20with%20tools%20warm%20natural%20light%20through%20window%20muted%20earth%20tones%20editorial%20documentary%20photography%20no%20people%20no%20text%20no%20logos&width=800&height=600&seq=noren-about-workshop&orientation=landscape"
                alt="Traditional Japanese workshop interior with warm natural light" loading="lazy"
                className="w-full h-80 md:h-96 object-cover border border-hairline" />
              <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm px-4 py-2 border border-hairline">
                <p className="text-xs text-ink/50">{t("about.locationLabel")}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full px-4 md:px-8 lg:px-12 mb-20">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold mb-8">{t("about.valuesLabel")}</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { title: t("about.value1Title"), body: t("about.value1Body") },
              { title: t("about.value2Title"), body: t("about.value2Body") },
              { title: t("about.value3Title"), body: t("about.value3Body") },
            ].map((v) => (
              <div key={v.title} className="bg-white border border-hairline p-6 md:p-8">
                <h3 className="font-serif text-lg font-semibold text-ink mb-3">{v.title}</h3>
                <p className="text-sm text-ink/50 leading-relaxed font-light">{v.body}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="w-full px-4 md:px-8 lg:px-12 mb-20">
          <div className="bg-ink p-8 md:p-12">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
              {[
                { num: "40+", label: t("about.statsProps") },
                { num: "6", label: t("about.statsPrefs") },
                { num: "100%", label: t("about.statsSupport") },
                { num: "0", label: t("about.statsFees") },
              ].map((stat) => (
                <div key={stat.label}>
                  <p className="font-serif text-3xl md:text-4xl font-semibold text-gold mb-2">{stat.num}</p>
                  <p className="text-xs text-paper/40 uppercase tracking-wider">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="w-full px-4 md:px-8 lg:px-12 mb-20">
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold mb-4">{t("about.teamLabel")}</p>
            <h2 className="font-serif text-2xl md:text-3xl font-semibold text-ink mb-4">{t("about.teamTitle")}</h2>
            <p className="text-ink/50 font-light leading-relaxed mb-8">{t("about.teamDesc")}</p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
              {[
                { role: t("about.roleSourcing"), desc: t("about.roleSourcingDesc") },
                { role: t("about.roleReno"), desc: t("about.roleRenoDesc") },
                { role: t("about.roleOps"), desc: t("about.roleOpsDesc") },
              ].map((t2) => (
                <div key={t2.role} className="bg-white border border-hairline p-5">
                  <p className="text-xs font-semibold uppercase tracking-wider text-ink/40 mb-2">{t2.role}</p>
                  <p className="text-sm text-ink/50 font-light">{t2.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="font-serif text-2xl md:text-3xl font-semibold text-ink mb-4">{t("about.ctaTitle")}</h2>
            <p className="text-ink/50 font-light mb-8">{t("about.ctaDesc")}</p>
            <Link to="/contact"
              className="inline-flex items-center gap-2 bg-ink text-paper text-sm font-medium px-8 py-3.5 rounded-full hover:bg-indigo transition-colors duration-300 whitespace-nowrap">
              {t("btn.getInTouch")}
              <i className="ri-arrow-right-up-line text-sm"></i>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}